import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

global._isSP = false;

// ===========================================================
//  共通ユーティリティ
// ===========================================================

// DOM 構築完了を待ってコールバックを実行
var domReady = function(cb){
  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", cb);
  }else{
    cb();
  }
};

// スムーススクロール(easeInOutQuad)
var easeInOutQuad = function(t){ return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; };
var smoothScrollTo = function(endY, duration){
  var startY = window.pageYOffset;
  var diff = endY - startY;
  var startT = null;
  var step = function(ts){
    if(startT === null) startT = ts;
    var p = Math.min((ts - startT) / duration, 1);
    window.scrollTo(0, startY + diff * easeInOutQuad(p));
    if(p < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
};

// scroll / resize 監視ハブ : rAF スロットルで、登録した全コールバックを
// ウィンドウリスナー1本にまとめて実行する
var makeRafHub = function(eventName){
  var callbacks = [];
  var ticking = false;
  var run = function(){
    ticking = false;
    for(var i = 0; i < callbacks.length; i++) callbacks[i]();
  };
  window.addEventListener(eventName, function(){
    if(!ticking){
      ticking = true;
      requestAnimationFrame(run);
    }
  }, { passive: true });
  return function(cb){ callbacks.push(cb); };
};

// ===========================================================
//  メイン初期化
// ===========================================================
var Init = function(){
  var $window = $(window);
  var $html = $("html");
  var $header = $("#header_rn");

  // ヘッダー実高さ(px)。#header_rn が無ければ 0
  var headerHeight = function(){ return $header.length ? $header.outerHeight() : 0; };

  if($window.width() < 768){
    _isSP = true;
  }

  // scroll / resize はハブへ集約(ウィンドウリスナーは各1本のみ)
  var onScroll = makeRafHub("scroll");
  var onResize = makeRafHub("resize");

  var ScrollFunc = function(){
    $html[0].style.setProperty("--header", headerHeight());
  };
  onScroll(ScrollFunc);
  ScrollFunc();

  $(".pagetop").on("click", function(){
    smoothScrollTo(0, 300);
  });

  var Resize = function(){
    $html[0].style.setProperty("--header", headerHeight());
    if($window.width() < 768){
      _isSP = true;
    }else{
      _isSP = false;
    }
  };
  onResize(Resize);
  Resize();

  // ===========================================================
  //  information : イベントバナー カルーセル(Swiper)
  // ===========================================================
  var initCarousel = function(){
    var slider = document.querySelector(".p-osaka-information__slider");
    if(!slider) return;

    // ループ安定化 : スライドが10枚未満なら、元スライドを1グループずつ
    // 複製して追加し、10枚以上になるまで繰り返す
    var wrapper = slider.querySelector(".swiper-wrapper");
    if(wrapper){
      var originalSlides = Array.prototype.slice.call(wrapper.children);
      while(originalSlides.length && wrapper.children.length < 10){
        originalSlides.forEach(function(slide){
          wrapper.appendChild(slide.cloneNode(true));
        });
      }
    }

    new Swiper(slider, {
      modules: [Navigation, Autoplay],
      loop: true,
      centeredSlides: true,
      slidesPerView: 1.5,
      spaceBetween: "10%", // SP(≤750px)
      speed: 500,
      breakpoints: {
        768: {
          slidesPerView: 3.5,
          spaceBetween: 50
        } // PC(≥751px)
      },
      navigation: {
        prevEl: ".p-osaka-information__arrow--prev",
        nextEl: ".p-osaka-information__arrow--next"
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      }
    });
  };
  
  /*
  *
const swiper = new Swiper('.swiper', {
  slidesPerView: 3.5,
  spaceBetween: 40,
  centeredSlides: true,
  autoHeight: true,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  scrollbar: {
    el: ".swiper-scrollbar"
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: true
  }
});
  * */
  

  // ===========================================================
  //  EVENT ボタン : スクロール中は画面固定、
  //  フッター手前まで来たらドッキングして停止
  // ===========================================================
  var initEventButton = function(){
    var btn = document.querySelector(".p-osaka-event");
    var footer = document.querySelector("#footer");
    var osaka = document.querySelector("#osaka"); // ボタンの position:absolute 基準
    if(!btn || !footer || !osaka) return;

    var DOCKED = "is-docked";
    var GAP = 30;       // フッターとの余白(px)
    var base = 0;       // 通常時(position:fixed)の bottom 値

    var update = function(){
      var footerTop = footer.getBoundingClientRect().top; // 画面基準のフッター上端
      // フッター上端が、固定ボタン下端(画面高 - base)より GAP 分せり上がったらドッキング
      if(footerTop - GAP < window.innerHeight - base){
        // #osaka 基準の top を算出し、フッター上端の GAP px 上にボタン下端を合わせる
        btn.style.top = (footerTop - osaka.getBoundingClientRect().top - btn.offsetHeight - GAP) + "px";
        btn.classList.add(DOCKED);
      }else{
        btn.classList.remove(DOCKED);
        btn.style.top = "";
      }
    };

    // 通常時の bottom を再計測してから update(初期化・リサイズ時)
    var refresh = function(){
      btn.classList.remove(DOCKED);
      btn.style.top = "";
      base = parseFloat(window.getComputedStyle(btn).bottom) || 0;
      update();
    };

    onScroll(update);
    onResize(refresh);
    refresh();
  };

  // ===========================================================
  //  MENU : ハンバーガーボタンでメニューを開閉
  //  戻り値 : { setOpen } (アンカークリック処理から閉じるため)
  // ===========================================================
  var initMenu = function(){
    var menu = document.querySelector(".js-menu");
    var toggle = document.querySelector(".js-menu-toggle");
    if(!menu || !toggle) return null;

    var OPEN = "is-open";
    var panel = menu.querySelector(".p-osaka-menu__panel");

    var setOpen = function(open){
      menu.classList.toggle(OPEN, open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      if(panel) panel.setAttribute("aria-hidden", open ? "false" : "true");
      // 背面のスクロールロック(.is-modal : overflow-y:hidden)
      // document.documentElement.classList.toggle("is-modal", open);
    };

    toggle.addEventListener("click", function(){
      setOpen(!menu.classList.contains(OPEN));
    });

    // Esc キーで閉じる
    document.addEventListener("keydown", function(e){
      if((e.key === "Escape" || e.keyCode === 27) && menu.classList.contains(OPEN)){
        setOpen(false);
      }
    });

    return { setOpen: setOpen };
  };

  // ===========================================================
  //  MENU ボタン : .offerContents 上端から一定マージンで配置
  //  (ヘッダー手前で固定)
  // ===========================================================
  var initMenuButton = function(){
    var btn = document.querySelector(".p-osaka-menu__btn");
    var panel = document.querySelector(".p-osaka-menu__panel");
    var offer = document.querySelector(".offerContents");
    if(!btn || !offer) return;

    var MARGIN = 30; // .offerContents 上端からの余白
    var GAP = 30;    // ヘッダー手前で止まる際の余白

    var update = function(){
      var offerTop = offer.getBoundingClientRect().top; // 画面基準の .offerContents 上端
      var headerH = headerHeight();
      // ボタン : 基本は「.offerContents 上端 + MARGIN」、スクロール時は「ヘッダー下端 + GAP」を下限にクランプ
      btn.style.top = Math.max(headerH + GAP, offerTop + MARGIN) + "px";
      // パネル : .offerContents 上端にピタッと密着(マージンなし)。スクロール時はヘッダー下端を下限にクランプ
      if(panel) panel.style.top = Math.max(headerH, offerTop) + "px";
    };

    onScroll(update);
    onResize(update);
    update();
  };

  // ----- 各機能の初期化 -----
  initCarousel();
  initEventButton();
  var menuApi = initMenu();
  initMenuButton();

  // ===========================================================
  //  アンカーリンク(.anchor) : スムーススクロールを一元処理
  //  メニュー内リンクは 500ms + メニューを閉じる、それ以外は 300ms
  // ===========================================================
  document.addEventListener("click", function(e){
    var link = e.target.closest(".anchor");
    if(!link) return;
    var hash = link.getAttribute("href") || "";
    if(hash.charAt(0) !== "#") return; // 外部/別ページリンクは通常遷移に委ねる
    var target = hash.length > 1 ? document.querySelector(hash) : null;
    if(hash.length > 1 && !target) return; // 対象が無ければ通常遷移に委ねる

    e.preventDefault();
    var inMenu = !!link.closest(".js-menu"); // メニュー内リンクか
    // target が無い(href="#")場合はページ先頭へ
    var endY = target ? (window.pageYOffset + target.getBoundingClientRect().top - headerHeight()) : 0;
    smoothScrollTo(endY, inMenu ? 500 : 300);
    if(inMenu && menuApi) menuApi.setOpen(false); // メニュー経由なら閉じる
  });

};

// jQuery(jQueryD)読込 → DOM 構築完了、の両方が揃ってから Init
var _initTimer = setInterval(function(){
  if(typeof jQueryD !== 'undefined'){
    clearInterval(_initTimer);
    global.$ = global.jQuery = jQueryD;
    domReady(Init);
  }
}, 100);
